<div class="card">
    <span class="p-input-icon-left mb-20">
        <i class="pi pi-search"></i>
        <input type="text" pInputText placeholder="Search" [(ngModel)]="value3"/>
    </span>
    <br/>
    <p-table [value]="contacts" styleClass="p-datatable-gridlines" [(selection)]="contact3" dataKey="code" responsiveLayout="scroll">
        <ng-template pTemplate="header">
        </ng-template>
        <ng-template pTemplate="body" let-contact>
            <tr>
                <td>
                    <p-tableRadioButton></p-tableRadioButton>
                </td>
                <td class="fs14">{{contact.name}}<br/>{{contact.number}}</td>
            </tr>
        </ng-template>
    </p-table>
</div>
